import { Action, Address, Link } from '@/types/general';

export interface BeneficiarySummary {
  uri?: string;
  esrSubscriberNumber?: string;
  iban?: string;
  accountNumber?: string;
  name?: string;
  description?: string;
  myPictureUri?: string;
  beneficiaryType?: PaymentType;
}

export interface Beneficiary {
  accountNumber: string;
  iban: string;
  beneficiaryType: PaymentType;
  name: string;
  description?: string;
  currency: string;
  myPicture_uri?: string;
  address?: Address;
  swiftBIC?: string;
  paymentInputProposal?: {
    amount: string;
    currency: string;
    paymentType: PaymentType;
    paymentReason: string;
    reference: string;
    referenceType: string;
    y2yPayment: boolean;
  };
  _links: {
    self: Link;
  };
  _actions?: {
    edit?: Action;
  };
}

export enum PaymentType {
  ESR = 'domestic_esr',
  IBAN = 'domestic_iban',
  InternationalIBAN = 'international_iban',
  QrIBAN = 'domestic_qr_iban',
  QrQrIBAN = 'domestic_qr_qriban',
  Wise = 'international_wise',
  WiseBusiness = 'international_wisebusiness'
}
